import React from "react";
import AppRoutes from "./router";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
